import React, { useMemo } from "react";
import { contactDetails, getInfoByField } from "@lib/utils/orderInfoUtility";
import { Flex } from "@ecco/ui/flex";
import { summaryStyles } from "../CheckoutStyles";
import { Box } from "@ecco/ui/box";
import { Text } from "@ecco/ui/text";
import type { ContactDetailsInitialValues } from "@lib/utils/checkoutHelper";
import { useLocale } from "next-intl";
import { getPrivacyAttributes } from "@lib/monitoring/privacyAttributes";
type Props = {
    values: ContactDetailsInitialValues;
};

export const ContactDetailsStepSummary = ({ values }: Props) => {
    const locale = useLocale();

    const contactDetailsSpec = contactDetails("");

    const renderContactDetails = useMemo(() => {
        const info = getInfoByField(contactDetailsSpec, values, locale);

        return (
            <Flex flexDirection="column" gap="2">
                {info.value.map((item, index) => (
                    <Text {...summaryStyles.summaryText} key={index}>
                        {item}
                    </Text>
                ))}
            </Flex>
        );
    }, [contactDetailsSpec, values]);

    return (
        <Flex
            flexDirection="column"
            gap="6"
            alignItems="stretch"
            justifyContent="flex-start"
            {...getPrivacyAttributes()}
        >
            <Box {...summaryStyles.column}>{renderContactDetails}</Box>
        </Flex>
    );
};
